import { Stack } from "@mui/material";
import TimezoneSelect from "Components/TimezoneSelect/TimezoneSelect";
import { CurrencyPicker } from "features/currency";
import { TextValidator } from "react-material-ui-form-validator";

function ProjectFormInner({
  name,
  setName,
  timezone,
  setTimezone,
  currency,
  setCurrency,
  overview,
  setOverview,
  disabled,
}) {
  return <Stack spacing={2}>
    <TextValidator
      variant="outlined"
      fullWidth
      name="project name"
      label="Project name *"
      helperText="e.g. incendium"
      value={name}
      disabled={disabled}
      validators={["required", "minStringLength:4"]}
      size="small"
      errorMessages={[
        "Project Name is Required",
        "Project Name Must be Over 3 Characters Long",
      ]}
      onChange={(e: any) => setName(e.target.value)}
    />

    <TimezoneSelect
      value={timezone}
      fullWidth
      size="small"
      variant="outlined"
      helperText="Select Project timezone, this will override the clients timezone."
      label="Select Project Timezone*"
      onChange={(e) => setTimezone(e.target.value)}
    />

    <CurrencyPicker
      currency={currency}
      setCurrency={setCurrency}
      label="Currency Symbol"
      helperText="Select Project currency symbol to display in reporting."
    />

    <TextValidator
      variant="outlined"
      multiline
      rows={3}
      rowsMax={6}
      fullWidth
      name="overview"
      label="Overview"
      helperText="Give a brief descrption of your business"
      validators={["maxStringLength:512"]}
      errorMessages={["Overview must be less than 512 characters"]}
      value={overview}
      size="small"
      disabled={disabled}
      onChange={(e: any) => setOverview(e.target.value)}
    />
  </Stack>
}

export default ProjectFormInner;